import type { IOffer } from '@bridebook/models/source/models/Suppliers/Offers.types';
import { OfferTypes } from '@bridebook/web/lib/offers/constants';

const getBBDiscount = (offers?: IOffer[] | null) => {
  const discount = offers?.find((o) => o.type === OfferTypes.bbDiscount)?.discount;

  return !discount ? 'None' : typeof discount === 'number' ? `${discount}%` : discount;
};

export default getBBDiscount;
